module.exports = __webpack_public_path__ + "static/img/img_2.935b6e9e.png";